import { render, staticRenderFns } from "./ManagementFeature.vue?vue&type=template&id=582c056b&"
import script from "./ManagementFeature.vue?vue&type=script&lang=ts&"
export * from "./ManagementFeature.vue?vue&type=script&lang=ts&"
import style0 from "./ManagementFeature.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports